import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_export_inventory_adjustmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { owner_lookup?: string, project_lookup: string, integration_id: string, transaction_type: string, transaction_id?: string, days?: number, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean }, operation_codes?: string[] }): Promise<{ messages?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_lookup)) {
      $missingRequiredInParams.push('\'project_lookup\'');
    }
    if (isNil($inParams.integration_id)) {
      $missingRequiredInParams.push('\'integration_id\'');
    }
    if (isNil($inParams.transaction_type)) {
      $missingRequiredInParams.push('\'transaction_type\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

